import { APIQueryResult, useAPIQuery } from 'shared/api/APIQuery';
import { requestCarrierAPI } from 'shared/api/CarrierAPIClient';
import { useFlaggedSchema } from 'shared/hooks/useFlaggedSchema';
import {
  VerifiedCarrierApplicationStatusDTO,
  verifiedCarrierApplicationStatusSchema,
  verifiedCarrierApplicationStatusYupSchema,
} from './VerifiedCarrierApplicationStatusDTO';

export function useVerifiedCarrierApplicationStatus(): APIQueryResult<VerifiedCarrierApplicationStatusDTO> {
  const schema = useFlaggedSchema(
    'ctms_zod_schema',
    verifiedCarrierApplicationStatusYupSchema,
    verifiedCarrierApplicationStatusSchema,
  );

  return useAPIQuery(
    ['verified-carrier-application', 'status'],
    () =>
      requestCarrierAPI(
        'GET /internal/web/carrier/verified-carrier-application/status/',
      ),
    { schema },
  );
}
